import publicAxios from "../../utils/publicAxios";
import { getVerify2FACodeURL } from "../../utils/constants/apiEndPoints";
import { showToast } from "../../utils/utils";
import { NAME_REGEX, showToastType } from "../../utils/constants/appConstants";
import { login } from "../../locales/en";
import { persistUserRoles } from "../../utils/accountRoles";
import recordMarketingIdentifiers from "../../utils/recordMarketingIdentifiers";

export default function useSubmitTwoFACode({
  values,
  errors,
  setErrors,
  setSuccess,
  setLoading,
  loginMixpanelEvent,
  loginGA4Event,
  handleGetOnboardingData
}) {
  const handleSubmitTwoFACode = async (event) => {
    event.preventDefault();

    let isValid = true;

    const newErrors = { ...errors };

    if (values.email.trim() === "") {
      newErrors.email = login?.errorMSG.enterPassword;
      isValid = false;
    } else if (NAME_REGEX.test(values.email)) {
      newErrors.email = login?.errorMSG.enterEmail;
      isValid = false;
    }

    if (values.twoFARequired === true) {
      if (values.twoFactorCode.trim() === "") {
        newErrors.twoFactorCode = login?.errorMSG.enter2FA;
        isValid = false;
        setSuccess((prevSuccess) => ({
          ...prevSuccess,
          twoFactorResent: null
        }));
      }
    }

    if (values.password.trim() === "") {
      newErrors.password = [login?.errorMSG.enterPassword];
      isValid = false;
    }

    setErrors(newErrors);

    if (isValid) {
      setLoading((prev) => ({ ...prev, sendTwoFaBtn: true }));

      const userData = {
        email: values.email,
        password: values.password,
        ...(values.twoFARequired && {
          twoFARequired: values.twoFARequired,
          twoFactorCode: values.twoFactorCode
        })
      };

      try {
        const response = await publicAxios.post(getVerify2FACodeURL, userData);

        if (response.status === 200) {
          // Mirror the non-2FA login path: persist role names so the portal/client
          // headers can offer the partner<->client account toggle to dual-role
          // users. Without this, 2FA-enabled dual accounts log in with empty roles.
          persistUserRoles(response?.data?.data?.user?.roles ?? []);
          loginMixpanelEvent(response?.data?.data);
          loginGA4Event(response?.data?.data?.user?.id);
          recordMarketingIdentifiers();
          handleGetOnboardingData();
          showToast(response.data.message, showToastType.success);
        }
      } catch (error) {
        const status = error.response?.status;
        // 400 is a rejected code; 423 is the lockout after three of them. Both carry
        // the sentence to show, and a status handled by neither leaves the previous
        // attempt's message on screen — which reads as "wrong code" to someone whose
        // account has just been locked.
        if (status === 400 || status === 423) {
          setErrors((prev) => ({
            ...prev,
            invalidMessage: error.response.data.message
          }));
          setSuccess((prevSuccess) => ({
            ...prevSuccess,
            twoFactorResent: null
          }));
        }
      } finally {
        setLoading((prev) => ({ ...prev, sendTwoFaBtn: false }));
      }
    }
  };

  return handleSubmitTwoFACode;
}
